import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=2c563baa&lang=pug&"
import script from "./Overall.vue?vue&type=script&lang=ts&"
export * from "./Overall.vue?vue&type=script&lang=ts&"
import style0 from "./Overall.vue?vue&type=style&index=0&id=2c563baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports